import { useUser } from '@/contexts/UserContext'
import { useWelcomeBack } from '@/hooks/use-welcome-back'
import { WhatsNewDialog } from '@/components/whats-new/WhatsNewDialog'
import { WelcomeBackDialog } from '@/components/welcome-back/WelcomeBackDialog'

/**
 * The dialogs that can open by themselves when somebody arrives: the welcome-back summary and
 * What's New. One owner so they take turns rather than stacking two modals on top of each other.
 *
 * Welcome-back goes first because it is about the person's own work; What's New waits until it
 * closes and then opens if it has anything to say.
 *
 * Gated on the user resolving for the same reason as WhatsNewDialog: the per-user storage behind
 * both is read in useState initialisers, which run once.
 */
export function StartupDialogs() {
  const { currentUser, isLoading } = useUser()
  if (isLoading || !currentUser?.id) return null
  return <StartupDialogsForUser key={currentUser.id} />
}

function StartupDialogsForUser() {
  const welcome = useWelcomeBack()
  return (
    <>
      <WelcomeBackDialog open={welcome.open} onClose={welcome.close} />
      <WhatsNewDialog suppressed={welcome.open} />
    </>
  )
}
